"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var knownCharCodeAt_1 = require("./knownCharCodeAt");
exports.convertChar = function (char, font, reverse) {
    if (reverse === void 0) { reverse = false; }
    var left = reverse ? 1 : 0;
    var right = reverse ? 0 : 1;
    if (font.missing.includes(char)) {
        return char[0];
    }
    else {
        var charCode_1 = knownCharCodeAt_1.knownCharCodeAt(char, 0);
        var n = font.chars.find(function (a) { return a[left] === charCode_1; });
        if (!n) {
            return char[0];
        }
        else {
            try {
                var o = String.fromCodePoint(n[right]);
                return o;
            }
            catch (ex) {
                console.log('Error in character ', n, String.fromCodePoint(n[left]), 'of font', font.name);
                return char[0];
            }
        }
    }
};
//# sourceMappingURL=convertChart.js.map